import { useEffect } from "react";
import { api } from "@/lib/api";

let cached = null;
let inflight = null;

function fetchSeo() {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = api.get("/public/seo").then(({ data }) => {
    cached = data;
    inflight = null;
    return data;
  }).catch(() => null);
  return inflight;
}

function setMeta(name, content, attr = "name") {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Injecte les balises SEO globales (titre, description, OG, Twitter) dans le <head>.
 * Le titre peut être surchargé par page via le paramètre `pageTitle`.
 */
export function useSeoMeta(pageTitle) {
  useEffect(() => {
    let cancelled = false;
    fetchSeo().then((seo) => {
      if (cancelled || !seo) return;
      const title = pageTitle ? `${pageTitle} · ${seo.seo_title || "WiLink"}` : (seo.seo_title || "WiLink");
      document.title = title;
      setMeta("description", seo.seo_description);
      setMeta("keywords", seo.seo_keywords);
      setMeta("author", seo.seo_author);
      // Open Graph
      setMeta("og:title", title, "property");
      setMeta("og:description", seo.seo_description, "property");
      setMeta("og:type", "website", "property");
      setMeta("og:url", seo.seo_og_url, "property");
      setMeta("og:image", seo.seo_og_image, "property");
      // Twitter
      setMeta("twitter:card", seo.seo_og_image ? "summary_large_image" : "summary");
      setMeta("twitter:title", title);
      setMeta("twitter:description", seo.seo_description);
      setMeta("twitter:image", seo.seo_og_image);
      if (seo.seo_twitter_handle) setMeta("twitter:site", seo.seo_twitter_handle);
      // Canonical
      if (seo.seo_og_url) setLink("canonical", seo.seo_og_url);
    });
    return () => { cancelled = true; };
  }, [pageTitle]);
}

// Force refresh quand l'admin sauvegarde (appelable manuellement)
export function invalidateSeoCache() {
  cached = null;
}
